export default __webpack_public_path__ + "static/media/buyFindDeals.8fcc58d4.png";